/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum CodeStatus {
    UnUsed = '0',
    InUse = 1,
    Expired = 2,
}
